import { Box, Typography } from '@mui/material';
import Seo from '../components/Seo';
import PageShell from '../components/PageShell';
import AppStoreBadges from '../components/AppStoreBadges';

const steps = [
  {
    icon: '/Upload.gif',
    title: 'Swipe',
    body: 'Every scroll is a different real mobile game. No autoplay videos. No screenshots that lie about gameplay. Real, playable content tuned to your taste.',
  },
  {
    icon: '/PieChart.gif',
    title: 'Play',
    body: 'Each gamic is one full, repeatable level of a real mobile game. Built in HTML5 and playable instantly inside BingePlay. No install. No 800 MB download. No signup.',
  },
  {
    icon: '/Annocement.gif',
    title: 'Download',
    body: 'Found a game you love? Tap download. BingePlay takes you straight to the App Store or Google Play to install the full game. The ones you skip never touch your phone.',
  },
];

export default function HowItWorks() {
  return (
    <PageShell>
      <Seo
        path="/how-it-works"
        title="How It Works"
        description="BingePlay is the TikTok for games. Swipe through real mobile games. Play one level instantly. Download only the ones you love."
      />
      <Box sx={{ px: { xs: 2, sm: 4, md: 6 }, maxWidth: 1100, mx: 'auto', textAlign: 'center' }}>
        <Typography
          component="h1"
          sx={{
            color: '#fff',
            fontFamily: 'Rammetto One',
            textTransform: 'uppercase',
            fontWeight: 800,
            fontSize: { xs: 30, sm: 44, md: 56, lg: 64 },
            lineHeight: 1.1,
            mt: { xs: 2, sm: 4 },
          }}
        >
          Stop downloading games you&apos;ll uninstall in 30 seconds.
        </Typography>
        <Typography
          sx={{
            color: '#ddd',
            fontFamily: 'Poppins',
            mt: { xs: 2, sm: 3 },
            fontSize: { xs: 14, sm: 18, md: 20 },
            maxWidth: 720,
            mx: 'auto',
            letterSpacing: '0.02em',
          }}
        >
          BingePlay is a swipeable feed of real mobile games. Each one playable in 1 tap, with zero
          install. Try before you download. Find your next obsession in 15 seconds.
        </Typography>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: { xs: 3, md: 4 },
            mt: { xs: 5, sm: 8 },
          }}
        >
          {steps.map((s, i) => (
            <Box
              key={s.title}
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: '20px',
                backdropFilter: 'blur(10px)',
                backgroundColor: 'rgba(255,255,255,0.08)',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1.5,
              }}
            >
              <Box
                component="img"
                src={s.icon}
                alt={s.title}
                sx={{ width: { xs: 90, md: 120 }, height: 'auto' }}
              />
              <Typography
                sx={{
                  color: '#fff',
                  fontFamily: 'Rammetto One',
                  textTransform: 'uppercase',
                  fontSize: { xs: 22, md: 26 },
                }}
              >
                {String(i + 1).padStart(2, '0')} · {s.title}
              </Typography>
              <Typography
                sx={{
                  color: '#ddd',
                  fontFamily: 'Poppins',
                  fontSize: { xs: 14, md: 16 },
                  letterSpacing: '0.01em',
                  lineHeight: 1.5,
                }}
              >
                {s.body}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box sx={{ mt: { xs: 6, sm: 8 } }}>
          <Typography
            sx={{
              color: '#fff',
              fontFamily: 'Poppins',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              fontSize: { xs: 12, sm: 14 },
            }}
          >
            Try it now
          </Typography>
          <AppStoreBadges />
        </Box>
      </Box>
    </PageShell>
  );
}
